import { Alert } from '@mui/material'
import { useGetData } from '../context/getDataContext'
import { getDocumentExpirationSummary } from '../utils/documentExpiration'

const formatExpiredCount = (count) =>
  count === 1 ? '1 documento vencido' : `${count} documentos vencidos`

const formatExpiringSoonCount = (count) =>
  count === 1
    ? '1 documento próximo do vencimento'
    : `${count} documentos próximos do vencimento`

const ExpirationAlert = () => {
  const { expiredDocuments, expiredDocumentsLoading, expiredDocumentsError } =
    useGetData()

  if (
    expiredDocumentsLoading ||
    expiredDocumentsError ||
    expiredDocuments.length === 0
  ) {
    return null
  }

  const { expiredCount, expiringSoonCount, severity } =
    getDocumentExpirationSummary(expiredDocuments)
  const messageParts = []

  if (expiredCount > 0) messageParts.push(formatExpiredCount(expiredCount))
  if (expiringSoonCount > 0) {
    messageParts.push(formatExpiringSoonCount(expiringSoonCount))
  }

  if (messageParts.length === 0) return null

  return (
    <Alert
      className="!text-xs !md:text-base mb-2"
      severity={severity}
      action={
        <a
          href="/documentos-vencidos"
          className="cursor-pointer font-bold underline opacity-80 hover:opacity-100 transition-colors"
        >
          Ver detalhes
        </a>
      }
    >
      Há {messageParts.join(' e ')}.{' '}
    </Alert>
  )
}

export default ExpirationAlert
